import { del, postJson } from 'utils/http';

export function saveListing(id: string, type: string) {
  return postJson(`/data/saved-listings`, { id, type });
}

export function unsaveListing(id: string, type: string) {
  return del(`/data/saved-listings/${type}/${id}`);
}
